import store from '../Store/configureStore';

import { denormalize } from 'normalizr';
import * as schemas from '../Schemas/OrderSchema.js';

export const denormalizerService = {
	orderDenormalizer,
	userDenormalizer
};

function orderDenormalizer(order) {
	const state = store.getState();
	return denormalize(order, schemas.orderSchema, state);
}

function userDenormalizer(user){
	const state = store.getState();
	return denormalize(user, schemas.userSchema, state);
}